import { Bounce, toast, ToastOptions, ToastPosition } from "react-toastify";

const getOptions = (
  autoClose: number,
  position?: ToastPosition,
): ToastOptions => {
  return {
    position: position ?? "bottom-center",
    autoClose: autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Bounce,
  };
};

export const showSuccessToast = (
  title: string,
  autoClose?: number,
  position?: ToastPosition,
) => {
  toast.dismiss();
  toast.success(title, getOptions(autoClose ?? 5000, position));
};

export const showErrorToast = (
  title: string,
  autoClose?: number,
  position?: ToastPosition,
) => {
  toast.dismiss();
  toast.error(title, getOptions(autoClose ?? 3000, position));
};
